module.exports = __webpack_public_path__ + "img/stock3.981183c1.png";